<template>
    <v-container fluid>
      <v-dialog
              v-model="showloading"
              hide-overlay
              persistent
              width="300"
      >
        <v-card
                color="secondary"
                dark
        >
          <v-card-text>
            <v-progress-linear
                    indeterminate
                    color="white"
                    class="ma-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-layout row>
        <v-subheader>Transactions/Deposits</v-subheader>
        <v-spacer></v-spacer>

        <v-text-field
                single-line
                hide-details
                height="24px"
                class="ma-0 pt-1"
                placeholder="search orders"
                v-model="searchString"
                prepend-icon="search"
                @keyup.enter="getSearched"
        ></v-text-field>

        <v-btn icon @click="loadOrders(0)"><v-icon color="grey darken-3">refresh</v-icon></v-btn>

        <v-icon @click="changeOrderStatus()" :class="[errorStatus? 'orange--text': 'grey--text']">error</v-icon>

        <v-btn icon :disabled="currentPage <= 0" @click="loadOrders(-1)"><v-icon color="grey darken-3">keyboard_arrow_left</v-icon></v-btn>
        <v-subheader>
          <small>{{ currentPageDate() }}</small>
        </v-subheader>
        <v-btn icon :disabled="errorStatus" @click="loadOrders(1)"><v-icon color="grey darken-3">keyboard_arrow_right</v-icon></v-btn>
      </v-layout>

      <v-layout row class="grey lighten-2 pa-2">
        <v-flex class="xs1 ml-3">
          #
          <v-icon>check_circle</v-icon>
          <v-icon class="ml-4 pl-1">loop</v-icon>
        </v-flex>
        <v-flex class="xs1 ml-1 pl-2">
          <h4 class="subheading">status</h4>
        </v-flex>
        <v-flex class="xs1 ">
          <h4 class="subheading">shopify#</h4>
        </v-flex>
        <v-flex class="xs1 pl-2">
          <h4 class="subheading">so#</h4>
        </v-flex>
        <v-flex class="xs1 ml-3">
          <h4 class="subheading">date</h4>
        </v-flex>
        <v-flex class="xs1 ml-3">
          <h4 class="subheading">time</h4>
        </v-flex>
        <v-flex class="xs1 ">
          <h4 class="subheading">order.status</h4>
        </v-flex>
        <v-flex class="xs1">
          <h4 class="subheading">message</h4>
        </v-flex>
      </v-layout>




      <div class="scrolly">
        <v-list subheader>
          <v-list-tile
                  class="listitem"
                  v-for="(item, i) in items"
                  :key="i"
                  avatar
          >
            <small>{{i < 9 ? "0" + (i + 1) : (i + 1)}}</small>
            <v-list-tile-avatar>
              <v-icon @click="markAsResolved(i)" v-if="item.transaction_status !== 'success'" :class="[item.transaction_status === 'failure'? 'red--text':'orange--text']">error</v-icon>
              <v-icon v-else color="blue">check_circle</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-avatar>
              <v-btn icon @click="retryTransaction(i)" :disabled="item.transaction_status === 'success'"><v-icon>loop</v-icon></v-btn>
            </v-list-tile-avatar>

            <v-list-tile-content>
              <v-container fluid class="pl-0">
                <v-layout row class="">
                  <v-flex class="xs1  ml-1">
                    <h4 :class="[item.transaction_status === 'success'? 'blue--text' : (item.transaction_status === 'pending'? 'grey--text' : 'red--text'), 'text--darken-3']">
                      <strong>{{item.transaction_status.toUpperCase()}}</strong>
                    </h4>
                  </v-flex>
                  <v-flex class="xs1 ml-2">
                    <small>

                      <a :href="(item.store_name.toLowerCase() === 'roqus' ? storeUrl.roqus : storeUrl.screenprinting) + '/admin/orders/'+item.salesorder_id.substring(20)"
                         target="_blank">
                        {{item.transaction_id?item.transaction_id.substring(31):'undefined'}}
                      </a>

                    </small>
                  </v-flex>
                  <v-flex class="xs1 ml-4">
                    <small>
                      <a :href="(item.store_name.toLowerCase() === 'roqus' ? storeUrl.roqus : storeUrl.screenprinting) + '/admin/orders/'+item.salesorder_id.substring(20)"
                         target="_blank">
                        {{item.salesorder_id?item.salesorder_id.substring(20):'undefined'}}
                      </a>

                    </small>
                  </v-flex>
                  <v-flex class="xs1 ml-3">
                    <small>
                      <v-flex class="xs1">
                        <small>
                          {{new Date(item.createdAt).toLocaleDateString('en-US')}}
                        </small>
                      </v-flex>
                      <v-flex class="xs1">
                        <small>
                          {{new Date(item.createdAt).toLocaleTimeString('en-US')}}
                        </small>
                      </v-flex>
                    </small>
                  </v-flex>
                  <v-flex class="xs1">
                    <small :class="[item.order_status === 'success'? 'blue--text' : (item.order_status === 'pending'? 'grey--text' : 'red--text'), 'text--darken-3']">
                      <strong>{{item.order_status.toLowerCase()}}</strong>
                    </small>
                  </v-flex>
                  <v-flex class="ml-3">
                    <small>{{item.store_name + " | " + (item.transaction_error || '')}}</small>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </div>
    </v-container>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.listitem {
  border-bottom: lightgrey solid 1px;
  border-top: lightgrey solid 1px;
}
.scrolly {
  overflow: auto;
  height: 74vh;
}
</style>

<script>
  //const API_URL = 'http://192.168.1.117:3000/graphql';
  const API_URL = '/graphql';

  export default{
    name: "OrderStatusList",
    data() {
      return {
        showloading: false,
        showloadingT: true,
        storeUrl: {roqus : 'https://roq-us.myshopify.com', screenprinting: 'https://ryonet.myshopify.com'},
        items: [],
        currentPage: 0,
        errorStatus: false,
      }
    },
    created() {
      this.loadOrders(0);
    },
    computed:{

    },
    methods: {
      changeOrderStatus() {
        this.errorStatus = !this.errorStatus;
        this.loadOrders(0);
      },
      currentPageDate() {
        let newDate = new Date();
        newDate.setDate( newDate.getDate() - this.currentPage);
        return newDate.toDateString();
      },
      markAsResolved(i) {
        this.showloading = true;
        if(confirm("Mark As Resolved?")){
          // Call API to Change status to resolved
          fetch(API_URL, {
            method: 'POST',
            body: JSON.stringify({"query": `mutation{
                      resolveOrder(input: {salesorder_id:"${this.items[i].salesorder_id}", transaction_status:"success", transaction_error: "Manually Resolved"}){
                        salesorder_id
                      }
                    }`
            }),
            headers: {
              'content-type': 'application/json'
            }
          }).then(response => response.json()).then(result => {
            this.showloading = false;
            this.loadOrders(0);
          }).catch(e => { this.showloading = false; console.log("ERROR: " + e); });
        }
      },
      rerun() {
        alert("Re-Running this order creation...")
      },
      retryTransaction(i) {
        this.showloading = true;
        fetch(API_URL, {
          method: 'POST',
          body: JSON.stringify({"query": `mutation{
                      retryTransaction(id: "${this.items[i].salesorder_id}"){
                        salesorder_id
                      }
                    }`
          }),
          headers: {
            'content-type': 'application/json'
          }
        }).then(response => response.json()).then(result => {
          this.showloading = false;
          this.loadOrders(0);
        }).catch(e => { this.showloading = false; alert("ERROR: " + e); });
      },
      loadOrders(page){
        this.currentPage = page === 0 ? page : this.currentPage + page;
        this.showloading = true;
        fetch(API_URL, {
          method: 'POST',
          body: JSON.stringify({"query": `{
                      ordersByDate(page: "${this.currentPage}", error: "${this.errorStatus}"){
                        transaction_id
                        salesorder_id
                        order_status
                        transaction_status
                        transaction_error
                        createdAt
                        store_name
                      }
                    }`
          }),
          headers: {
            'content-type': 'application/json'
          }
        }).then(response => response.json()).then(result => {
          let resultItems = result.data.ordersByDate;
          resultItems.sort(function(a, b){return new Date(b.createdAt) - new Date(a.createdAt)});
          this.showloading = false;
          this.items = resultItems;
          console.log(result);
          try {
            console.log(JSON.stringify(result));
          } catch (e) { console.log(e); }
        }).catch(e =>{ this.showloading = false;});
      },
    }
  }

</script>
